import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mountain, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("logout_reason") === "inactivity") {
      localStorage.removeItem("logout_reason");
      toast.info("You were signed out due to inactivity. Please sign in again.");
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex bg-[#0B132B]">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-11 h-11 rounded-sm bg-white/10 flex items-center justify-center"><Mountain className="w-6 h-6 text-white" /></div>
            <div>
              <div className="text-white font-bold text-lg font-head tracking-tight">AEROBENT MINECHEM</div>
              <div className="text-slate-400 text-[11px] uppercase tracking-widest">Private Limited · ERP</div>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-white font-head mb-1">Sign in</h1>
          <p className="text-slate-400 text-sm mb-6">Internal business management system</p>
          <form onSubmit={submit} className="space-y-4" autoComplete="off">
            <div className="space-y-1.5">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">Email</label>
              <Input data-testid="login-email" type="email" autoComplete="off" placeholder="you@aerobentminechem.com" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-white/5 border-white/15 text-white placeholder:text-slate-500" />
            </div>
            <div className="space-y-1.5">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">Password</label>
              <Input data-testid="login-password" type="password" autoComplete="off" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-white/5 border-white/15 text-white placeholder:text-slate-500" />
            </div>
            <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full bg-white text-[#0B132B] hover:bg-slate-100 rounded-sm font-semibold h-11">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
            </Button>
          </form>
          <p className="text-slate-500 text-xs mt-6 leading-relaxed">
            Enter your assigned company email and password. Contact your administrator if you need access.
          </p>
        </div>
      </div>
      <div className="hidden lg:block flex-1 relative">
        <img src="https://images.unsplash.com/photo-1760224255774-66b3ab88bd83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="cover" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-[#0B132B]/40" />
      </div>
    </div>
  );
}
